import style from './mini-cart.module.scss';
import { Scrollbars } from 'react-custom-scrollbars';
import cx from 'classnames';
import { NavLink } from 'react-router-dom';
import {
  FaTimes as CloseIcon,
  FaRegTrashAlt as DeleteIcon
} from 'react-icons/fa';
import { useCartContext } from '../../../context/CartContext/CartContext';

export interface miniCartProps {
  opened: boolean;
  setOpened: React.Dispatch<React.SetStateAction<boolean>>;
}

function MiniCart({ opened, setOpened }: miniCartProps) {
  const { cart, cartRemoveProduct } = useCartContext();

  // Helper function to safely calculate and format prices
  const calculatePrices = (cart: any) => {
    if (!cart || !cart.totalWithFactor) {
      return {
        subtotal: 0,
        pdv: 0,
        total: 0
      };
    }
    // Prices are already in the main currency unit. No division needed.
    const baseTotal = cart.totalWithFactor;
    const pdvAmount = baseTotal * 0.2;
    const finalTotal = baseTotal + pdvAmount;

    return {
      subtotal: baseTotal,
      pdv: pdvAmount,
      total: finalTotal
    };
  };

  const prices = calculatePrices(cart);

  return (
    <div className={cx(style.miniCartWrapper, opened ? style.opened : null)}>
      <div className={style.miniCartContainer}>
        <div className={style.header}>
          <div className={style.title}>Pregled Rezervacije</div>
          <CloseIcon
            className={style.closeIcon}
            onClick={() => setOpened((opened: boolean) => !opened)}
          />
        </div>
        {cart?.hasStartEndDates() && (
          <div className={style.reservationInfo}>
            <div className={style.infoRow}>
              <span>Broj dana:</span>
              <span>{cart.numberOfDays}</span>
            </div>
            <div className={style.infoRow}>
              <span>Multiplikator cene:</span>
              <span>{cart?.priceFactor?.toFixed(2) ?? '0'}x</span>
            </div>
          </div>
        )}
        <div className={style.productsWrapper}>
          <Scrollbars className={style.scrollbarWrapper}>
            {cart?.products.map((product) => {
              // Calculate the adjusted price for each item, without dividing by 100
              const adjustedPrice =
                cart.priceFactor > 1
                  ? product.price * cart.priceFactor
                  : product.price;

              return (
                <div className={style.cartProduct} key={product.id}>
                  <div className={style.imageWrapper}>
                    <img
                      src={product.getMainImageUrl() ?? ''}
                      alt={product.name}
                    />
                  </div>
                  <div className={style.contentWrapper}>
                    <div className={style.left}>
                      <div className={style.name}>{product.name}</div>
                      <div className={style.price}>
                        {/* Display the correctly formatted adjusted price */}
                        {adjustedPrice.toFixed(2)}{' '}
                        {process.env.REACT_APP_DEFAULT_CURRENCY}
                      </div>
                    </div>
                    <div className={style.right}>
                      <span
                        className={style.deleteButton}
                        onClick={() => cartRemoveProduct(product.id)}
                      >
                        <DeleteIcon />
                      </span>
                    </div>
                  </div>
                </div>
              );
            })}
          </Scrollbars>
        </div>
        {cart && (
          <div className={style.priceSummary}>
            {/* Subtotal before PDV */}
            <div className={style.priceRow}>
              <span>Ukupno bez PDV-a:</span>
              <span>
                {prices.subtotal.toFixed(2)}{' '}
                {process.env.REACT_APP_DEFAULT_CURRENCY}
              </span>
            </div>
            {/* PDV Amount */}
            <div className={style.priceRow}>
              <span>PDV (20%):</span>
              <span>
                {prices.pdv.toFixed(2)} {process.env.REACT_APP_DEFAULT_CURRENCY}
              </span>
            </div>
            {/* Final Total with PDV */}
            <div className={cx(style.priceRow, style.totalRow)}>
              <span>Ukupno sa PDV-om:</span>
              <span>
                {prices.total.toFixed(2)}{' '}
                {process.env.REACT_APP_DEFAULT_CURRENCY}
              </span>
            </div>
          </div>
        )}
        <div className={style.footer}>
          <NavLink
            className={style.buttonPrimary}
            onClick={() => setOpened(false)}
            to="/cart"
          >
            Pregled odabranog
          </NavLink>
          <NavLink
            className={style.buttonSecondary}
            onClick={() => setOpened(false)}
            to="/checkout"
          >
            Rezerviši
          </NavLink>
        </div>
      </div>
    </div>
  );
}
export default MiniCart;
